<template>
    <v-container grid-list-xs fluid>
        <v-row>
            <v-col cols="6" class="text-center">
                <label>
                    <h2>General net income</h2>
                </label>
                <Bar :chart-options="chartOptions" :chart-data="net" :chart-id="'bar-chart'" dataset-id-key="label" />
            </v-col>
            <v-col class="text-center">
                <label>
                    <h2>General details</h2>
                </label>
                <v-row>
                    <v-col v-for="spc in specifics" cols="6">
                        <Bar style="height: 200px;" :chart-options="chartOptions" :chart-data="spc" chart-id="line"
                            dataset-id-key="label" />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="4" class="text-center">
                <label>
                    <h2>Net income by region</h2>
                </label>
                <Bar :chart-options="chartOptions" :chart-data="netRegions" chart-id="doughnut-chart"
                    dataset-id-key="label" />
            </v-col>

            <v-col class="text-center">
                <label>
                    <h2>General details by region</h2>
                </label>
                <v-row>
                    <v-col v-for="spc in specificRgns" cols="6">
                        <Bar style="height: 200px;" :chart-options="chartOptionsX" :chart-data="spc" chart-id="line"
                            dataset-id-key="label" />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
// import Dispatch from '@/components/Dispatch/Dispatch';
import axios from 'axios';
import { Line as LineChartGenerator } from 'vue-chartjs/legacy';
import { Bar } from 'vue-chartjs/legacy';
import { Doughnut } from 'vue-chartjs/legacy'
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement,
    ArcElement,
    BarElement,
} from 'chart.js';

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement,
    BarElement,
    ArcElement
);
export default {
    props: ['year','order','typeBy'],
    components: {
        LineChart: LineChartGenerator,
        Bar,
        Doughnut
    },
    watch: {
        '$store.state.analytics.StartTime': function () {
            this.getDataDash();
        },
        '$store.state.analytics.EndTime': function () {
            this.getDataDash();
        },
        'typeBy': function () {
            this.getDataDash();
        },
        'order': function () {
            this.getDataDash();
        },
    },
    data: function () {
        return {
            years: [2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030],
            net: [],
            specifics: [],
            netRegions: [],
            specificRgns: [],
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        beginAtZero: true
                    }
                }
            },
            chartOptionsX: {
                responsive: true,
                maintainAspectRatio: false,
                indexAxis: 'y',
                scales: {
                    x: {
                        beginAtZero: true
                    }
                }
            }
        }
    },
    mounted() {
        this.getDataDash();
    },
    methods: {
        getDataDash: function () {
            let str = this.$store;
            this.specifics = [];
            str.state.isLoading = true;
            const parms = {
                StartDate : this.$store.state.analytics.StartTime,
                EndDate : this.$store.state.analytics.EndTime,
                TypeBy: this.typeBy,
                OrderBy : this.order.id
            }
            axios
                .post('dashboard/general/dash',parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {

                    const specifics = ['Revenue', 'OtherRev', 'Expenses', 'OtherExp'];
                    this.netRegions = this.dataRegions(response.data['region']);
                    this.net = this.dataGeneral(response.data['month']);
                    this.specificRgns = this.specificRegions(response.data['region'], specifics);
                    console.log('Here SpR', this.specificRgns);
                    specifics.forEach(async x => {
                        const labels = response.data['month'].map(x => {
                            return x.Month;
                        });
                        const data = await response.data['month'].map(spc => {
                            return spc[x];
                        });
                        const all = {
                            labels: labels,
                            datasets: [
                                {
                                    data: data,
                                    label: x,
                                    backgroundColor: this.getRandomColor(),
                                    fill: false
                                }
                            ]

                        }
                        this.specifics.push(all);
                    });
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
        },
        dataRegions(data) {
            console.log(data);
            const labels = data.map(x => {
                return x.PrincipalRegion;
            });
            const values = data.map(x => {
                return x.Net;
            });
            const colors = data.map(x => {
                console.log(x.PrincipalRegion);
                return "#0D47A1";
            });
            const row = {
                labels: labels,
                datasets: [
                    {
                        label:'Net income',
                        backgroundColor: colors,
                        data: values
                    }
                ]
            }
            return row;
        },
        dataGeneral(data) {
            const labels = data.map(x => {
                return x.Month;
            });

            const values = data.map(x => {
                return x.Net;
            });
            const row = {
                labels: labels,
                datasets: [
                    {
                        data: values,
                        label: "Net Amount",
                        backgroundColor: "#0D47A1",
                        fill: false
                    }
                ]
            }
            return row;
        },
        specificRegions(data, cat) {
            var spcReg = [];
            cat.forEach(async spc => {
                const regions = await data.map(x => {
                    return x[spc];
                });
                const labels = await data.map(x => {
                    return x.PrincipalRegion;
                });
                const row = {
                    labels: labels,
                    datasets: [
                        {
                            data: regions,
                            label: spc,
                            backgroundColor: this.getRandomColor(),
                            fill: false
                        }
                    ]
                }
                spcReg.push(row);
            });
            console.log(spcReg);
            return spcReg;
        },
        getRandomColor() {
            return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
        }
    }
};
</script>
